/**
 * Typed HTTP client for the Macksons loyalty API, built on openapi-fetch (MIT) and the
 * openapi-typescript types generated from `openapi.yaml` (`src/generated/openapi.generated.ts`).
 *
 * Points and LKR minor-unit amounts stay decimal integer strings on the wire; parse them with
 * the zod schemas from this package when `bigint` values are needed.
 */
import createClient, {} from 'openapi-fetch';
/**
 * Creates a typed client. `baseUrl` should include the version prefix, e.g.
 * `https://api.localhost/v1`; operation paths (`/member/wallet`, …) are appended to it.
 */
export function createApiClient(baseUrl, opts = {}) {
    if (!baseUrl)
        throw new TypeError('createApiClient: baseUrl is required');
    const clientOptions = { baseUrl: baseUrl.replace(/\/+$/, '') };
    if (opts.fetch)
        clientOptions.fetch = opts.fetch;
    if (opts.headers)
        clientOptions.headers = opts.headers;
    const client = createClient(clientOptions);
    const { getAccessToken } = opts;
    if (getAccessToken) {
        client.use({
            async onRequest({ request }) {
                const token = await getAccessToken();
                if (token && !request.headers.has('Authorization')) {
                    request.headers.set('Authorization', `Bearer ${token}`);
                }
                return request;
            },
        });
    }
    for (const mw of opts.middleware ?? [])
        client.use(mw);
    return client;
}
//# sourceMappingURL=client.js.map